const ErrorComponent = () => {
    const errorLayout = (
        <div className="error-component">
            <p className="error-message">something went wrong (or) the URL doesn't exist.</p>
            <a className="error-url" href="https://hariof98.vercel.app/">
                please check out this link
            </a>
        </div>
    );

    return errorLayout;
};

export default ErrorComponent;
